import { Link, useLocation } from "react-router-dom";
import { Package } from "lucide-react";
import { IkonTambah } from "./Ikon";
import { rupiah } from "../lib/format";
import { coverThumb } from "../lib/media";
import { asalNavigasiHp } from "./navigasiHp";

// Kartu produk 2 kolom (papan B1d "Semua Produk" / "Produk Terlaris", B10 Katalog). Tombol "+" = jumlah minimum produk, atau + satu kelipatan bila sudah ada di keranjang (useTambah).
// peringkat = #1–#4 Produk Terlaris beranda (HP-1b, isian admin terlaris_beranda); kosong = tanpa lencana.
// PR harga kartu HP (papan A, keputusan Haryanto 04/11/2026): baris 1 = harga yang dibayar di jumlah minimal (server: p.harga_minimum, fungsi
// keranjang, tanpa voucher); baris 2 bila diskon > 0 = harga dasar dicoret + lencana -X%; tombol + 36 px di kanan, di tengah tinggi dua baris.
export function KartuProdukHp({ p, tambahKartu, sibuk, geser = false, eager = false, peringkat = null }) {
  const lokasi = useLocation();
  const img = coverThumb(p);
  const kosong = p.ketersediaan === "KOSONG";
  const terbatas = p.ketersediaan === "TERBATAS";
  const href = `/produk/${p.slug || p.id}`;
  const label = kosong ? `${p.nama} kosong, belum bisa ditambahkan` : `Tambah ${p.nama} ke keranjang`;
  const hm = p.harga_minimum;
  const diskon = !!(hm && hm.persen_diskon > 0);

  return (
    <article className={`hp-kartu${geser ? " hp-kartu--geser" : ""}${kosong ? " is-kosong" : ""}`} data-testid={`hp-kartu-${p.id}`}>
      <Link to={href} state={asalNavigasiHp(lokasi)} className="hp-kartu__link" data-testid={`hp-kartu-link-${p.id}`}>
        {img ? (
          <img src={img} alt={p.nama} width="400" height="400" loading={eager ? "eager" : "lazy"} decoding="async" draggable={false}
            onContextMenu={(e) => e.preventDefault()} className="hp-kartu__foto foto-tanpa-simpan" />
        ) : (
          <span className="hp-kartu__foto hp-kartu__foto--kosong" aria-hidden="true"><Package size={36} strokeWidth={1.5} /></span>
        )}
        {peringkat && <span className="hp-kartu__lencana is-peringkat" data-testid={`hp-peringkat-${p.id}`}>#{peringkat}</span>}
        {kosong && <span className={`hp-kartu__lencana is-abu${peringkat ? " is-kanan" : ""}`}>Kosong</span>}
        {terbatas && <span className={`hp-kartu__lencana${peringkat ? " is-kanan" : ""}`}>Terbatas</span>}
      </Link>
      <div className="hp-kartu__isi">
        <Link to={href} state={asalNavigasiHp(lokasi)} className="hp-kartu__nama">{p.nama}</Link>
        <div className="hp-kartu__bawah">
          <Link to={href} state={asalNavigasiHp(lokasi)} className="hp-kartu__teks" data-testid={`hp-kartu-harga-${p.id}`}>
            <span className="hp-kartu__harga-teks"><b className="hp-kartu__harga">{rupiah(diskon ? hm.harga_efektif : p.harga_satuan)}</b><span className="hp-kartu__per">/pc</span></span>
            {diskon && (
              <span className="hp-kartu__coret" data-testid={`hp-kartu-coret-${p.id}`}>
                <span className="hp-sr">Harga sebelum diskon </span><s>{rupiah(p.harga_satuan)}</s>
                <span className="hp-kartu__persen">-{hm.persen_diskon}%</span>
              </span>
            )}
          </Link>
          <div className="hp-kartu__tambah">
            <button type="button" aria-label={label} disabled={kosong || sibuk === p.id} onClick={() => tambahKartu(p)}
              data-testid={`hp-tambah-${p.id}`}>
              <span><IkonTambah /></span>
            </button>
          </div>
        </div>
      </div>
    </article>
  );
}
